module.exports = __webpack_public_path__ + "fonts/sourcesansproblackitalic.7af3114d.ttf";